import { HumanGreetingProximityIcon } from './HumanGreetingProximityIcon';

/**
 * author: Google
 * id 200F7489-F20F-4506-A27A-081A0CA8A312
 * name human-greeting-proximity
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-greeting-proximity.svg
 * tags
 * - Account / User 
 * - People / Family 
 */
export const ConnectWithoutContactIcon = HumanGreetingProximityIcon;
export default ConnectWithoutContactIcon